import { createHostModule } from '@wix/sdk-runtime/host-modules';
export const locationRuntime = createHostModule({
    baseUrl: ({ channel }) => function baseUrl(...args) {
        return channel.invoke({
            namespace: 'location',
            method: 'baseUrl',
            args,
        });
    },
    path: ({ channel }) => function path(...args) {
        return channel.invoke({
            namespace: 'location',
            method: 'path',
            args,
        });
    },
    prefix: ({ channel }) => function prefix(...args) {
        return channel.invoke({
            namespace: 'location',
            method: 'prefix',
            args,
        });
    },
    protocol: ({ channel }) => function protocol(...args) {
        return channel.invoke({
            namespace: 'location',
            method: 'protocol',
            args,
        });
    },
    query: ({ channel }) => function query(...args) {
        return channel.invoke({
            namespace: 'location',
            method: 'query',
            args,
        });
    },
    url: ({ channel }) => function url(...args) {
        return channel.invoke({
            namespace: 'location',
            method: 'url',
            args,
        });
    },
    onChange: ({ channel }) => function onChange(...args) {
        return channel.invoke({
            namespace: 'location',
            method: 'onChange',
            args,
        });
    },
    to: ({ channel }) => function to(...args) {
        return channel.invoke({
            namespace: 'location',
            method: 'to',
            args,
        });
    },
});
//# sourceMappingURL=location.runtime.js.map